import { createRoot } from 'react-dom/client'
import ApolloProvider from './ApolloProvider'
import reportWebVitals from './reportWebVitals'
import 'react-loading-skeleton/dist/skeleton.css'
const container = document.getElementById('root')!
const root = createRoot(container)

root.render(ApolloProvider)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
